import axios from 'axios';
import { isWechat } from '~/utils/browser';

/**
 * 判斷是否處於 AlipayHK 系列環境（App / 小程式 / 開發工具）
 * 只在 client 端有效，server 端一律返回 false
 */
function isAlipayHKEnv() {
  if (!process.client || typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return (
    ua.indexOf("AlipayHK") > -1 ||
    ua.indexOf("AlipayClientHK") > -1 ||
    ua.indexOf("MiniProgramStudio") > -1
  );
}

export default function ({ app, redirect }, inject) {
  // 從 i18n 配置取得可用 locales 和預設 locale
  const availableLocales = app.i18n.locales;
  const defaultLocale = app.i18n.defaultLocale;

  // AlipayHK 環境：在 plugin 初始化階段就強制設為 hk，
  // 早於任何 middleware / navigation / $locale() 呼叫
  if (isAlipayHKEnv() && availableLocales.includes("hk")) {
    app.i18n.setLocale("hk");
    app.$cookies.set("loc", "hk");
  }

  const locale = async () => {
    // 單一 locale 站點（如 tw 站），無需偵測，直接使用 defaultLocale
    if (availableLocales.length <= 1) {
      app.i18n.setLocale(defaultLocale);
      return;
    }

    // AlipayHK 系列環境：強制 hk，不做 IP 偵測
    if (isAlipayHKEnv() && availableLocales.includes("hk")) {
      app.i18n.setLocale("hk");
      app.$cookies.set("loc", "hk");
      return;
    }

    // 如果 cookie 已有值，直接使用（優先於 IP 偵測）
    const savedLoc = app.$cookies.get("loc");
    if (savedLoc) {
      app.i18n.setLocale(savedLoc);
      return;
    }

    // Cloudflare trace 只在 client 端執行，避免 SSR server 被 rate limit
    if (!process.client) {
      app.i18n.setLocale(defaultLocale);
      return;
    }

    // 多 locale 站點（如港澳站），透過 Cloudflare 偵測地區
    const url = "https://www.cloudflare.com/cdn-cgi/trace";
    try {
      const { data } = await axios.get(url);
      const json = data.split("\n").reduce((obj, pair) => {
        pair = pair.split("=");
        return (obj[pair[0]] = pair[1]), obj;
      }, {});

      const actualLoc = json.loc?.toLowerCase();

      // 從環境變量獲取受限制的地區列表
      const restrictedRegions = (process.env.WECHAT_RESTRICTED_REGIONS || 'cn').split(',');
      
      // 檢查是否為受限制地區且使用微信瀏覽器
      if (restrictedRegions.includes(actualLoc) && isWechat()) {
        const currentPath = app.router.currentRoute.fullPath;
        return redirect((process.env.WECHAT_REDIRECT_PATH || '/mp')+(currentPath ? `?from=${encodeURIComponent(currentPath)}` : ''));
      }

      // 根據 Cloudflare 偵測的地區匹配可用 locale，找不到則用 defaultLocale
      const detected = availableLocales.includes(actualLoc) ? actualLoc : defaultLocale;
      app.i18n.setLocale(detected);
      app.$cookies.set("loc", detected);
    } catch (error) {
      console.error("獲取地區信息失敗:", error);
      // 偵測失敗時使用 defaultLocale，但不覆蓋已有的 cookie
      app.i18n.setLocale(defaultLocale);
    }
  };

  inject('locale', locale);
}
